import React from "react";
import AlertSec from "../Alert/AlertSec";
import FirstSec from "../FirstSec/FirstSec";
import SecondSec from "../SecondSec/SecondSec";
import ThirdSec from "../ThirdSec/ThirdSec";
import FourthSec from "../FourthSec/FourthSec";
import FifthSec from "../FifthSec/FifthSec";
import SixthSec from "../SixthSec/SixthSec";
import YoutubeVideos from "./YoutubeVideos";

function Main() {
  return (
    <>
      <AlertSec />
      <FirstSec />
      <SecondSec />
      <ThirdSec />
      <FourthSec />
      <FifthSec />
      <SixthSec />
      {/* <YoutubeVideos /> */}
    </>
  );
}

export default Main;
